module.exports = __webpack_public_path__ + "media/images/front/icons/favorite-e028c9e558b59da396b7d66bca158074.png";